// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as DrawerState$Showside from "../context/DrawerState.bs.js";
import * as BaseWithTheme$Showside from "../context/BaseWithTheme.bs.js";
import * as ErrorReporter$Showside from "../components/ErrorReporter.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as CategoryFinder$Showside from "../types/CategoryFinder.bs.js";
import * as LocationConfig$Showside from "../utils/LocationConfig.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as SectionContent$Showside from "../components/SectionContent.bs.js";
import * as RollbarInstance$Showside from "../utils/RollbarInstance.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as IntegrationUtils$Showside from "../utils/IntegrationUtils.bs.js";
import * as ShopifyAnalytics$Showside from "../utils/ShopifyAnalytics.bs.js";
import * as UseContextualL1s$Showside from "../hook/UseContextualL1s.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as EntrypointCallbacks$Showside from "../EntrypointCallbacks.bs.js";
import * as MiniCartDrawer_Lazy$Showside from "../components/MiniCartDrawer_Lazy.bs.js";
import * as RelatedMediaContent$Showside from "../components/RelatedMediaContent.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as QuickViewOverlay_Lazy$Showside from "../pages/QuickViewOverlay_Lazy.bs.js";
import * as ProductDetailsPage_Lazy$Showside from "../pages/ProductDetailsPage_Lazy.bs.js";
function SectionApp$EmbedRelatedMedia(Props) {
  var config = Props.config;
  var scrollableContainerRef = Props.scrollableContainerRef;
  var attributes = Props.attributes;
  var shopifyProductId = ShopifyAnalytics$Showside.getProductPageProductId(undefined);
  var shopifyCollectionId = ShopifyAnalytics$Showside.getCollectionPageCollectionId(undefined);
  var productId = Belt_Option.orElse(shopifyProductId, Belt_Option.flatMap(attributes, function (attr) {
    return attr.relatedProduct;
  }));
  var categoryId = Belt_Option.orElse(shopifyCollectionId, Belt_Option.flatMap(attributes, function (attr) {
    return attr.relatedCategory;
  }));
  var relatedMediaSource = productId !== undefined ? {
    TAG: /* ByProductIds */0,
    _0: [productId]
  } : categoryId !== undefined ? {
    TAG: /* ByCategoryId */1,
    _0: categoryId
  } : /* NoSource */0;
  var relatedMediaCount = React.useMemo(function () {
    return Belt_Array.get(Category$Showside.keepMapCategories(config.categories, function (category) {
      var connection = Category$Showside.ExternalConnection.getStoreCategoryConnection(category);
      if (connection !== undefined && Caml_obj.equal(connection.categoryId, categoryId)) {
        return connection.relatedMediaCount;
      }
    }), 0);
  }, []);
  var relatedMediaCardSize = Belt_Option.map(attributes, function (attr) {
    var match = attr.sectionCardSize;
    if (match !== undefined && match !== "medium") {
      if (match === "small") {
        return /* Small */0;
      } else {
        return /* Large */2;
      }
    } else {
      return /* Medium */1;
    }
  });
  var relatedMediaCardShape = Belt_Option.map(attributes, function (attr) {
    var match = attr.sectionCardShape;
    if (match !== undefined && match !== "square") {
      if (match === "portrait") {
        return /* Tall */0;
      } else {
        return /* Circle */2;
      }
    } else {
      return /* Square */1;
    }
  });
  var tmp = {
    at: /* StandaloneEmbed */3,
    scrollableContainerRef: scrollableContainerRef,
    source: relatedMediaSource,
    className: CSS$Showside.prefix("bg-main text-primary")
  };
  if (relatedMediaCount !== undefined) {
    tmp.count = relatedMediaCount;
  }
  if (relatedMediaCardShape !== undefined) {
    tmp.shape = Caml_option.valFromOption(relatedMediaCardShape);
  }
  if (relatedMediaCardSize !== undefined) {
    tmp.size = Caml_option.valFromOption(relatedMediaCardSize);
  }
  return React.createElement(RelatedMediaContent$Showside.Slider.make, tmp);
}
SectionApp$EmbedRelatedMedia.displayName = "SectionApp.EmbedRelatedMedia";
var EmbedRelatedMedia = {
  make: SectionApp$EmbedRelatedMedia
};
function SectionApp$EmbedNode(Props) {
  var config = Props.config;
  var scrollableContainerRef = Props.scrollableContainerRef;
  var attributes = Props.attributes;
  var match = LocationConfig$Showside.use(undefined);
  var match$1 = EntrypointContext$Showside.use(undefined);
  var targetedNode = React.useMemo(function () {
    var match = Belt_Option.flatMap(attributes, function (attr) {
      return attr.sectionType;
    });
    if (match !== undefined) {
      if (match === "root") {
        return Belt_Option.map(config.settings.indexNode, function (root) {
          var newrecord = Caml_obj.obj_dup(root);
          newrecord.categoryType = {
            TAG: /* Standard */1,
            _0: {
              firstCard: undefined,
              externalConnection: undefined,
              children: config.categories,
              loadMoreChildren: undefined,
              totalChildren: 0,
              link: undefined,
              products: [],
              taggedMedia: undefined,
              imageHotspots: undefined,
              imageWidth: undefined,
              imageHeight: undefined
            }
          };
          newrecord.showDescription = false;
          newrecord.showTitle = false;
          return newrecord;
        });
      } else if (match === "related-media") {
        return;
      } else {
        return Belt_Option.flatMap(Belt_Option.flatMap(attributes, function (attr) {
          return attr.sectionNode;
        }), function (nodeId) {
          return CategoryFinder$Showside.getCategoryById(config.categories, nodeId);
        });
      }
    }
  }, [attributes, config]);
  var targetedUserSelectedLayout = Belt_Option.map(targetedNode, function (node) {
    return node.userSelectedLayout;
  });
  var targetedNodeLayout;
  if (targetedUserSelectedLayout !== undefined && typeof targetedUserSelectedLayout !== "number") {
    switch (targetedUserSelectedLayout.TAG | 0) {
      case /* SubCategoriesGrid */2:
      case /* ProductGrid */3:
        targetedNodeLayout = {
          TAG: /* GridLayout */1,
          _0: targetedUserSelectedLayout._0
        };
        break;
      default:
        targetedNodeLayout = {
          TAG: /* SliderLayout */0,
          _0: targetedUserSelectedLayout._0
        };
    }
  } else {
    targetedNodeLayout = undefined;
  }
  var targetedPreferedContentType;
  if (targetedUserSelectedLayout !== undefined && typeof targetedUserSelectedLayout !== "number") {
    switch (targetedUserSelectedLayout.TAG | 0) {
      case /* ProductGrid */3:
      case /* ProductSlider */4:
        targetedPreferedContentType = /* Products */0;
        break;
      default:
        targetedPreferedContentType = /* Category */1;
    }
  } else {
    targetedPreferedContentType = undefined;
  }
  var onCategoryClick = IntegrationUtils$Showside.countBottombarElementsByNamespace(match.namespace) > 0 ? match$1.onCategoryClick : undefined;
  if (targetedNode === undefined) {
    return React.createElement(ErrorReporter$Showside.make, {
      error: RollbarInstance$Showside.makeError(false, "No targeted node")
    });
  }
  if (targetedNodeLayout === undefined) {
    return React.createElement(ErrorReporter$Showside.make, {
      error: RollbarInstance$Showside.makeError(false, "No targeted layout")
    });
  }
  if (targetedPreferedContentType === undefined) {
    return React.createElement(ErrorReporter$Showside.make, {
      error: RollbarInstance$Showside.makeError(false, "No targeted content type")
    });
  }
  var tmp = {
    index: 0,
    preferredContentType: targetedPreferedContentType,
    category: targetedNode,
    layout: targetedNodeLayout,
    scrollableContainerRef: scrollableContainerRef,
    className: CSS$Showside.prefix("bg-main text-primary")
  };
  if (onCategoryClick !== undefined) {
    tmp.onTitleClick = Caml_option.valFromOption(onCategoryClick);
  }
  return React.createElement(SectionContent$Showside.make, tmp);
}
SectionApp$EmbedNode.displayName = "SectionApp.EmbedNode";
var EmbedNode = {
  make: SectionApp$EmbedNode
};
function SectionApp(Props) {
  var attributes = Props.attributes;
  var embedType = Props.embedType;
  var match = LocationConfig$Showside.use(undefined);
  var namespace = match.namespace;
  var scrollableContainerRef = React.useRef(null);
  ViewportContext$Showside.use(undefined);
  var match$1 = RouterProvider$Showside.useRouter(undefined);
  var quickViewUnderlyingRoute = match$1.quickViewUnderlyingRoute;
  var route = match$1.route;
  var match$2 = ConfigurationProvider$Showside.use(undefined);
  var config = match$2.config;
  var contextualRoot = UseContextualL1s$Showside.useContextualRoot(/* Open */2, embedType, window.location.pathname);
  var pageOnlyHasSection = IntegrationUtils$Showside.countBottombarElementsByNamespace(namespace) === 0 && IntegrationUtils$Showside.countInlineElementsByNamespace(namespace) === 0 && IntegrationUtils$Showside.countLauncherElementsByNamespace(namespace) === 0;
  var match$3 = Belt_Option.flatMap(attributes, function (attr) {
    return attr.sectionType;
  });
  var tmp;
  tmp = typeof route === "number" || !(route.TAG === /* QuickView */3 && pageOnlyHasSection) ? null : React.createElement(QuickViewOverlay_Lazy$Showside.make, {});
  var tmp$1;
  var exit = 0;
  var exit$1 = 0;
  if (quickViewUnderlyingRoute !== undefined && !(typeof quickViewUnderlyingRoute === "number" || quickViewUnderlyingRoute.TAG !== /* PDP */2)) {
    exit = 1;
  } else {
    exit$1 = 2;
  }
  if (exit$1 === 2) {
    if (typeof route === "number" || route.TAG !== /* PDP */2) {
      tmp$1 = null;
    } else {
      exit = 1;
    }
  }
  if (exit === 1) {
    tmp$1 = pageOnlyHasSection ? React.createElement(ProductDetailsPage_Lazy$Showside.make, {}) : null;
  }
  var tmp$2 = {
    config: config,
    embedType: embedType,
    children: React.createElement(DrawerState$Showside.Provider.make, {
      value: /* Open */2,
      children: null
    }, React.createElement("div", {
      ref: ReactDOMUtils$Showside.Ref.domRef(scrollableContainerRef)
    }, match$3 !== undefined ? match$3 === "related-media" ? React.createElement(SectionApp$EmbedRelatedMedia, {
      config: config,
      scrollableContainerRef: scrollableContainerRef,
      attributes: attributes
    }) : React.createElement(SectionApp$EmbedNode, {
      config: config,
      scrollableContainerRef: scrollableContainerRef,
      attributes: attributes
    }) : React.createElement(ErrorReporter$Showside.make, {
      error: RollbarInstance$Showside.makeError(false, "Unknown value for attribute `type`")
    }), tmp, tmp$1), React.createElement(ConditionalRender$Showside.When.make, {
      condition: config.settings.cart,
      children: React.createElement(MiniCartDrawer_Lazy$Showside.make, {})
    }))
  };
  if (attributes !== undefined) {
    tmp$2.attributes = Caml_option.valFromOption(attributes);
  }
  if (contextualRoot !== undefined) {
    tmp$2.contextualRoot = Caml_option.valFromOption(contextualRoot);
  }
  return React.createElement(BaseWithTheme$Showside.make, {
    initiator: "section",
    portal: false,
    children: React.createElement(EntrypointCallbacks$Showside.make, tmp$2)
  });
}
SectionApp.displayName = "SectionApp";
var make = React.memo(SectionApp);
var $$default = make;
export { EmbedRelatedMedia, EmbedNode, make, $$default, $$default as default };
/* make Not a pure module */